import React from 'react';

const WebtaskLogo = props => (
  <svg width={32} height={32} viewBox="0 0 256 256" {...props}>
    <path fill="#5F3237" d="M256 256H0V0h256z" />
    <path fill="#E56E62" d="M256 256H51.2V51.2H256z" />
    <path fill="#ED955B" d="M204.8 204.8H51.2V51.2h153.6z" />
    <path fill="#F9E862" d="M204.8 204.8H102.4V102.4h102.4z" />
    <path fill="#FFF" d="M153.6 153.6h-51.2v-51.2h51.2z" />
  </svg>
);

export default WebtaskLogo;



// WEBPACK FOOTER //
// ./src/javascripts/app/Webhooks/templates/logos/WebtaskLogo.es6.js